<script>
import { required } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables/wgpt';
import { useKeyboardEvents } from 'dashboard/composables/useKeyboardEvents';

import Icon from 'dashboard/components-next/icon/Icon.vue';
import InputNext from 'dashboard/components-next/input/Input.vue';

export default {
  components: {
    Icon,
    InputNext,
  },
  props: {
    board: {
      type: Object,
      default: () => {},
    },
    list: {
      type: Object,
      default: () => {},
    },
    card: {
      type: Object,
      default: () => {},
    },
    readonly: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    useKeyboardEvents({
      Escape: {
        action: e => {
          if (e.target.id === 'wgpt-board-list-card-name-input') {
            e.preventDefault();
          }
        },
        allowOnFocusedInput: true,
      },
      Enter: {
        action: e => {
          e.preventDefault();
          e.target.blur();
        },
        allowOnFocusedInput: true,
      },
    });

    return { v$: useVuelidate() };
  },
  data() {
    return {
      name: '',
      isInputFocused: false,
    };
  },
  validations: {
    name: {
      required,
    },
  },
  watch: {
    card() {
      this.setDefaults();
    },
  },
  mounted() {
    this.setDefaults();
  },
  methods: {
    setDefaults() {
      this.name = this.card.name ?? '';
    },
    async onSubmit() {
      try {
        const name = this.name;
        if (!name) return;

        const boardId = this.board.id;
        const listId = this.list.id;
        const { id, name: nameBefore } = this.card;
        if (name === nameBefore) return;

        const data = {
          name: this.name,
        };
        await this.$store.dispatch('wgptBoardListCards/update', {
          boardId,
          listId,
          id,
          ...data,
        });
      } catch (error) {
        const errorMessage =
          error.message ||
          this.$t('WGPT_BOARDS.ITEM.LIST.CARD.EDIT.NAME.API.ERROR_MESSAGE');
        useAlert(errorMessage);
      }
    },
    onInputFocus() {
      this.isInputFocused = true;
    },
    onInputBlur() {
      this.isInputFocused = false;
      this.onSubmit();
    },
  },
};
</script>

<template>
  <div class="flex gap-4 mb-4">
    <Icon icon="i-lucide-id-card" class="mt-2.5 w-5 h-5 text-slate-500" />
    <div class="flex-1 w-full">
      <label :class="{ error: v$.name.$error }">
        <InputNext
          id="wgpt-board-list-card-name-input"
          v-model.trim="name"
          class="name-input"
          custom-input-class="name-native-input !bg-transparent disabled:!bg-transparent disabled:!cursor-text !text-slate-900 dark:!text-slate-100 !border-none !outline !outline-2 !outline-transparent -outline-offset-2 !m-0 text-xl !font-semibold"
          type="text"
          data-testid="board-list-card-name"
          :disabled="readonly"
          @focus="onInputFocus"
          @blur="onInputBlur"
          @enter="onSubmit"
        />
      </label>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.name-input {
  ::v-deep {
    input {
      padding: 8px !important;
      height: 40px !important;
      &:focus {
        outline-color: #fd6262 !important;
      }
    }
  }
}
</style>
